import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryDocument, CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFieldsFragment } from "../../../../../../generated";
import { HeaderDetail } from "./header-detail";

interface HeaderDetailContainerProps {
  caseId: string;
}

export const HeaderDetailContainer: React.FC<HeaderDetailContainerProps> = (props) => {
  const {
    data: archivedApplicantDetailData,
    loading: archivedApplicantDetailLoading,
    error: archivedApplicantDetailError,
  } = useQuery(
    CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryDocument,
    {
      variables: {
        archivedCredentialVerificationCaseSummaryId: props?.caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={archivedApplicantDetailLoading}
      hasData={archivedApplicantDetailData}
      error={archivedApplicantDetailError}
      hasDataComponent={
        <HeaderDetail
          data={
            archivedApplicantDetailData?.archivedCredentialVerificationCaseSummary as CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFieldsFragment
          }
        />
      }
    />
  );
};
